/** @format */

import hmac256 from 'crypto-js/hmac-sha256';

/**
 *
 * @param expires
 * @param permission string or array ['pick', 'store'] or 'read'
 * @param filepickerId
 * @returns {string}
 */
const getFilestackPolicy = (expires, permission = 'read', filepickerId = '') => {
    const data = {
        expiry: expires,
        call: permission
    };

    if (filepickerId) {
        data['handle'] = filepickerId;
    }
    return btoa(JSON.stringify(data));
};

const getFilestackSignature = policy => {
    return hmac256(policy, process.env.FILESTACK_SECRET).toString();
};

export {getFilestackPolicy, getFilestackSignature};
